import React from 'react';
import { Card } from 'primereact/card';
import { Image } from 'primereact/image';
import { Tag } from 'primereact/tag';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import './ArticleCard.css';

const ArticleCard = ({ article, className = '', onClick }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (onClick) {
      onClick(e, article);
    } else {
      navigate(`/article/${article.id}`, { 
        state: { article } 
      });
    }
  };

  const formatDate = (timestamp) => {
    if (!timestamp?.seconds) return '';
    return moment(timestamp.seconds * 1000).format('MMMM D, YYYY');
  };

  if (!article) return null;

  return (
    <Card 
      className={`article-card cursor-pointer h-full ${className}`}
      onClick={handleClick}
      header={
        article.thumbnail?.url || article.imageUrl ? (
          <div className="w-full overflow-hidden" style={{ height: '160px' }}>
            <Image 
              src={article.thumbnail?.url || article.imageUrl} 
              alt={article.thumbnail?.alt || article.title}
              width="100%"
              height="100%"
              style={{ objectFit: 'cover', width: '100%', height: '100%' }}
              preview
            />
          </div>
        ) : null
      }
    >
      <div className="flex flex-column h-full">
        <h3 className="text-xl font-semibold mb-2 line-clamp-2">{article.title}</h3>
        
        {(article.summary || article.description || article.excerpt) && (
          <p className="text-gray-600 mb-3 line-clamp-3">
            {article.summary || article.description || article.excerpt}
          </p>
        )}
        
        {article.tags?.length > 0 && (
          <div className="mt-auto pt-2 flex flex-wrap gap-2">
            {article.tags.slice(0, 3).map((tag, index) => (
              <Tag 
                key={index} 
                value={tag} 
                className="text-xs"
                severity="info"
              />
            ))}
            {article.tags.length > 3 && (
              <Tag value={`+${article.tags.length - 3}`} className="text-xs" />
            )}
          </div>
        )}
        
        <div className="mt-3 text-sm text-gray-500">
          {formatDate(article.updatedAt || article.createdAt)}
        </div>
      </div>
    </Card>
  );
};

export default ArticleCard;
